/**
 * Finds the request approval block for a given link id
 * @param {Array} workflows - The workflows to search through
 * @param {string} linkId - The id of the link to find the request approval block for
 * @returns {Array} The request approval blocks (may be empty)
 */
export const findRequestApprovalBlocksForLink = (workflows, linkId) => {
  if (!workflows || workflows.length === 0) return [];
  
  const requestApprovalBlocks = [];

  for (const workflow of workflows) {
    const blocks = workflow.snapshot.blocks.filter(b => b.key === 'requestApproval');
    
    for (const block of blocks) {
      // Reverse the path to start from its parent
      // Creating a new array to avoid mutating the original path
      const path = [...block.path].reverse();
      
      for (const blockId of path) {
        const parentBlock = workflow.snapshot.blocks.find(b => b.id === blockId);

        if (parentBlock.key === 'startAgreement' || parentBlock.key === 'generateDocument') {
          const linkedObjectId = parentBlock.variables['connected-object']?.value.id;
          if (linkedObjectId === linkId) {
            requestApprovalBlocks.push(block);
          }

          break;
        }
      }
    }
  }

  return requestApprovalBlocks;
};
